import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../lib/apiClient";
import { PageHeader } from "../components/Layout";
import { PlusCircle, Trash2, Ruler } from "lucide-react";
import { toast } from "sonner";

export default function SizesPage() {
  const [rows, setRows] = useState([]);
  const [name, setName] = useState("");

  const load = async () => {
    try {
      const { data } = await api.get("/sizes");
      setRows(data);
    } catch (e) { toast.error(formatApiError(e)); }
  };
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/sizes", { name });
      toast.success("Ölçü eklendi");
      setName("");
      load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  const del = async (id) => {
    if (!window.confirm("Bu ölçüyü silmek istediğinize emin misiniz?")) return;
    try { await api.delete(`/sizes/${id}`); load(); } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div>
      <PageHeader title="Ölçüler" subtitle="Sipariş formunda seçilebilecek ölçüler" />

      <form onSubmit={add} className="card-industrial p-6 mb-6" data-testid="new-size-form">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
          <label className="block md:col-span-3">
            <div className="text-[10px] uppercase tracking-widest font-bold text-slate-600 mb-1">Ölçü</div>
            <input required value={name} onChange={(e) => setName(e.target.value)} className="w-full px-3 py-2 border border-slate-400 bg-white rounded-none focus:border-blue-700 focus:outline-none font-mono" placeholder="180x200, 140x190..." data-testid="size-name" />
          </label>
          <button type="submit" data-testid="add-size-btn" className="inline-flex items-center justify-center gap-2 px-5 py-3 bg-blue-700 hover:bg-blue-800 text-white font-bold uppercase tracking-wide text-sm">
            <PlusCircle size={18} /> Ölçü Ekle
          </button>
        </div>
      </form>

      <div className="card-industrial overflow-x-auto">
        <table className="w-full text-sm" data-testid="sizes-table">
          <thead>
            <tr className="bg-slate-100 border-b border-slate-300 text-xs uppercase tracking-widest text-slate-600">
              <th className="text-left px-4 py-3">Ölçü</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={2} className="p-8 text-center text-slate-500"><Ruler className="inline mr-2 opacity-50"/> Henüz ölçü yok.</td></tr>}
            {rows.map((r, i) => (
              <tr key={r.id} className={`border-b border-slate-200 ${i % 2 === 0 ? "bg-white" : "bg-slate-50"}`} data-testid={`size-row-${r.name}`}>
                <td className="px-4 py-3 font-mono font-bold text-lg">{r.name}</td>
                <td className="px-4 py-3 text-right">
                  <button onClick={() => del(r.id)} className="text-red-700 hover:text-red-900 inline-flex items-center gap-1 text-sm font-bold" data-testid={`delete-size-${r.name}`}>
                    <Trash2 size={14} /> Sil
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
